module.exports = __webpack_public_path__ + "img/RegionsBank.9cd8156f.svg";